import { IUser } from "../../interfaces/user";

export class User {
    _id: string
    email: string

    constructor(item: IUser) {
        Object.keys(item).forEach((key: string) => {
            this[key] = item[key]
        })
    }
}
